var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrafts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h18v18H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093D54",
    d: "M1.586 3.028H.18v14.777h12.162v-1.406H1.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACE0F9",
    fillRule: "nonzero",
    d: "M1.586 3.028v13.37h12.162V1.623H1.586v1.406zm8.031 6.635H2.88v-1.1h6.737v1.1zm2.837-2.514H2.88v-1.1h9.574v1.1zm0-2.514H2.88v-1.1h9.574v1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5B7C",
    d: "M2.88 3.535v1.1h9.574v-1.1h-.112zm0 2.515v1.099h9.574v-1.1h-.112zm0 2.513h6.737v1.099H2.88zM15.217.04s-.234 0-.272.386c-.19 2.072-.3 7.647-.342 10.2-.022 1.303 0 5.214 0 5.214s.614 1.172.614 2.14m0-17.94s.234 0 .27.386c.192 2.072.3 7.647.343 10.2.023 1.303 0 5.214 0 5.214s-.613 1.172-.613 2.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACE0F9",
    d: "M14.983 15.658l.234-12.63.234 12.63z"
  }))));
}
export default SvgDrafts;